import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';

export const GameTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();

  return (
    <>
      <p>{t('onboarding.letsPlay')}</p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('buttons.playNow')}
      </Button>
    </>
  );
};
